export const ENV_DEV = 'development';
export const ENV_PRE = 'preproduction';
export const ENV_PRO = 'production';
export const ENV_TEST = 'test';

export default process.env.GATSBY_ENV || process.env.NODE_ENV || ENV_DEV;
